/* Paw & Co v2: juegos, selector de colores, huellas al pulsar y entradas. Cada parte arranca solo si su sección está en la página. */
(() => {
  if (window.__pc2) return;
  window.__pc2 = true;
  document.documentElement.classList.add('pc2-js');
  const reducido = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const HUELLA = '<svg viewBox="0 0 24 24" fill="currentColor"><ellipse cx="12" cy="15" rx="5" ry="4.2"/><circle cx="6" cy="9" r="2.1"/><circle cx="10" cy="6" r="2.1"/><circle cx="14" cy="6" r="2.1"/><circle cx="18" cy="9" r="2.1"/></svg>';
  const listo = fn => (document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', fn) : fn());

  listo(() => {
    // --- el perrito que te sigue por la cabecera ---
    document.querySelectorAll('[data-pc2-hero]').forEach(hero => {
      const perrito = hero.querySelector('[data-pc2-perrito]'), capa = hero.querySelector('[data-pc2-capa]'), aviso = hero.querySelector('[data-pc2-aviso]');
      if (!perrito || reducido) return;
      let px = 120, py = 140, tx = 260, ty = 160, ultimaH = 0, lado = 1, avisado = false;
      const objetivo = (cx, cy) => { const r = hero.getBoundingClientRect(); tx = cx - r.left; ty = Math.min(Math.max(cy - r.top, 60), r.height - 40); if (!avisado && aviso) { avisado = true; aviso.style.opacity = '0'; } };
      hero.addEventListener('pointermove', e => objetivo(e.clientX, e.clientY));
      hero.addEventListener('pointerdown', e => objetivo(e.clientX, e.clientY));
      const bucle = t => {
        const dx = tx - px, dy = ty - py, d = Math.hypot(dx, dy);
        if (d > 6) {
          const v = Math.min(d * 0.08, 9); px += dx / d * v; py += dy / d * v;
          perrito.classList.add('anda');
          if (Math.abs(dx) > 4) { const nl = dx < 0 ? -1 : 1; if (nl !== lado) { lado = nl; perrito.classList.toggle('izq', lado < 0); } }
          if (t - ultimaH > 160) { ultimaH = t; const h = document.createElement('div'); h.className = 'huella'; h.innerHTML = HUELLA; h.style.left = (px - lado * 30) + 'px'; h.style.top = (py + 32 + ((t / 160) % 2 ? 6 : -6)) + 'px'; h.style.rotate = (lado > 0 ? 90 : -90) + 'deg'; capa.appendChild(h); setTimeout(() => h.remove(), 2200); }
        } else perrito.classList.remove('anda');
        perrito.style.transform = `translate(${px - 55}px, ${py - 40}px)`;
        requestAnimationFrame(bucle);
      };
      requestAnimationFrame(bucle);
    });

    // --- las fotos hablan al tocarlas ---
    document.querySelectorAll('.pc2 .foto').forEach(f => f.addEventListener('click', () => { f.classList.remove('menea'); void f.offsetWidth; f.classList.add('menea'); setTimeout(() => f.classList.remove('menea'), 1400); }));

    // --- mapa del localizador: toca para mover al perro, botón para hacerlo sonar ---
    document.querySelectorAll('[data-pc2-mapa]').forEach(mapa => {
      const raiz = mapa.closest('.prueba, .cap') || mapa.parentElement;
      const pin = mapa.querySelector('.pin'), dist = raiz.querySelector('[data-pc2-dist]'), estado = raiz.querySelector('[data-pc2-estado]'), sonar = raiz.querySelector('[data-pc2-sonar]');
      let mx = 285, my = 250, mtx = 420, mty = 160, manual = 0, ip = 0;
      const paseos = [[420, 160], [520, 140], [470, 300], [330, 250], [200, 120]];
      setInterval(() => { if (Date.now() - manual > 5000) [mtx, mty] = paseos[ip++ % paseos.length]; }, 2600);
      mapa.addEventListener('pointerdown', e => { const r = mapa.getBoundingClientRect(), k = Math.max(600 / r.width, 460 / r.height), ox = (r.width * k - 600) / 2, oy = (r.height * k - 460) / 2; mtx = (e.clientX - r.left) * k - ox; mty = (e.clientY - r.top) * k - oy; manual = Date.now(); });
      mapa.style.touchAction = 'manipulation';
      const anima = () => {
        mx += (mtx - mx) * 0.03; my += (mty - my) * 0.03;
        pin.setAttribute('transform', `translate(${mx.toFixed(1)} ${my.toFixed(1)})`);
        if (dist) dist.textContent = dist.dataset.plantilla.replace('#m', Math.round(Math.hypot(mx - 110, my - 390) * 1.4));
        if (estado && !pin.classList.contains('suena')) estado.textContent = my > 170 && my < 320 && mx > 170 && mx < 400 ? estado.dataset.parque : estado.dataset.lejos;
        if (!reducido) requestAnimationFrame(anima);
      };
      anima();
      if (sonar) sonar.addEventListener('click', () => { pin.classList.remove('suena'); void pin.getBoundingClientRect(); pin.classList.add('suena'); if (estado) estado.textContent = estado.dataset.suena; setTimeout(() => pin.classList.remove('suena'), 3000); });
    });

    // --- jersey con pelos: pasa el dedo para quitarlos ---
    document.querySelectorAll('[data-pc2-tela]').forEach(tela => {
      const raiz = tela.closest('.prueba, .cap') || tela.parentElement;
      const cx = tela.getContext('2d'), pista = raiz.querySelector('[data-pc2-pista]'), pct = raiz.querySelector('[data-pc2-pct]'), estado = raiz.querySelector('[data-pc2-estado]');
      const limpio = document.createElement('canvas'); limpio.width = 900; limpio.height = 700;
      const lc = limpio.getContext('2d'); lc.fillStyle = '#2B2D3A'; lc.fillRect(0, 0, 900, 700);
      for (let y = 0; y < 700; y += 14) for (let x = 0; x < 900; x += 14) { lc.fillStyle = `rgba(255,255,255,${.02 + ((x / 14 + y / 14) % 2) * .025})`; lc.fillRect(x, y, 12, 12); }
      const celdas = new Set(); let frota = false, hecho = false;
      const pinta = () => {
        cx.drawImage(limpio, 0, 0); celdas.clear();
        for (let i = 0; i < 2200; i++) { const x = Math.random() * 900, y = Math.random() * 700, a = Math.random() * Math.PI, l = 18 + Math.random() * 34; cx.strokeStyle = Math.random() < .55 ? 'rgba(236,222,196,.9)' : 'rgba(205,160,110,.85)'; cx.lineWidth = 1.6 + Math.random() * 1.4; cx.beginPath(); cx.moveTo(x, y); cx.quadraticCurveTo(x + Math.cos(a) * l / 2 + 4, y + Math.sin(a) * l / 2 - 4, x + Math.cos(a) * l, y + Math.sin(a) * l); cx.stroke(); }
        if (pct) pct.textContent = '0 %'; if (estado) estado.textContent = estado.dataset.inicio;
      };
      pinta();
      const frotar = e => {
        const r = tela.getBoundingClientRect(), x = (e.clientX - r.left) * 900 / r.width, y = (e.clientY - r.top) * 700 / r.height;
        cx.save(); cx.beginPath(); cx.arc(x, y, 60, 0, Math.PI * 2); cx.clip(); cx.drawImage(limpio, 0, 0); cx.restore();
        for (let gx = Math.floor((x - 50) / 100); gx <= Math.floor((x + 50) / 100); gx++) for (let gy = Math.floor((y - 50) / 100); gy <= Math.floor((y + 50) / 100); gy++) if (gx >= 0 && gx < 9 && gy >= 0 && gy < 7) celdas.add(gx + ',' + gy);
        const p = Math.min(100, Math.round(celdas.size / 63 * 100 / .85));
        if (pct) pct.textContent = p + ' %'; if (estado) estado.textContent = p < 100 ? estado.dataset.limpiando : estado.dataset.fin;
        if (p >= 100 && !hecho) { hecho = true; if (pista) pista.textContent = pista.dataset.otra; }
      };
      tela.addEventListener('pointerdown', e => { frota = true; if (hecho) { hecho = false; pinta(); if (pista) pista.textContent = pista.dataset.txt; } else frotar(e); });
      tela.addEventListener('pointermove', e => { if (frota || e.pointerType === 'mouse') frotar(e); });
      addEventListener('pointerup', () => frota = false);
      tela.style.touchAction = 'none';
    });

    // --- pata con barro: mantener pulsado para limpiarla ---
    document.querySelectorAll('[data-pc2-lavadora]').forEach(lav => {
      const raiz = lav.closest('.prueba'), pulsa = raiz.querySelector('[data-pc2-pulsa]'), crono = raiz.querySelector('[data-pc2-crono]'), estado = raiz.querySelector('[data-pc2-estado]');
      const manchas = [...lav.querySelectorAll('.mancha')], TOTAL = 3.5;
      let t = 0, activo = false, ultimo = 0, hecho = false;
      const pinta = () => { crono.textContent = t.toFixed(1).replace('.', ',') + ' s'; manchas.forEach((m, i) => { const umbral = (i + 1) / (manchas.length + 1) * TOTAL; m.style.opacity = Math.max(0, 1 - (t - umbral * .6) / (TOTAL * .35)); }); };
      const para = () => { if (!activo) return; activo = false; lav.classList.remove('lava'); pulsa.setAttribute('aria-pressed', 'false'); if (t < TOTAL) estado.textContent = estado.dataset.falta; };
      const bucle = ts => {
        if (!activo) return;
        t = Math.min(TOTAL, t + (ts - (ultimo || ts)) / 1000); ultimo = ts; pinta();
        if (t >= TOTAL) { para(); hecho = true; estado.textContent = estado.dataset.fin; pulsa.textContent = pulsa.dataset.otra; return; }
        estado.textContent = estado.dataset.limpiando;
        requestAnimationFrame(bucle);
      };
      const empieza = e => { e.preventDefault(); if (hecho) { hecho = false; t = 0; pinta(); estado.textContent = estado.dataset.inicio; pulsa.textContent = pulsa.dataset.txt; return; } activo = true; ultimo = 0; lav.classList.add('lava'); pulsa.setAttribute('aria-pressed', 'true'); requestAnimationFrame(bucle); };
      pulsa.addEventListener('pointerdown', empieza);
      addEventListener('pointerup', para); pulsa.addEventListener('pointerleave', para);
      pulsa.addEventListener('keydown', e => { if ((e.key === ' ' || e.key === 'Enter') && !activo && !e.repeat) empieza(e); });
      pulsa.addEventListener('keyup', e => { if (e.key === ' ' || e.key === 'Enter') para(); });
      pinta();
    });

    // --- test: qué necesita tu peludo ---
    document.querySelectorAll('[data-pc2-test]').forEach(test => {
      const datos = JSON.parse(test.parentElement.querySelector('[data-pc2-datos]').textContent || '[]');
      const quien = test.querySelector('[data-pc2-quien]'), lio = test.querySelector('[data-pc2-lio]'), paso2 = test.querySelector('[data-pc2-paso2]'), res = test.querySelector('[data-pc2-resultado]');
      const esc = s => String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
      const marca = (g, b) => g.querySelectorAll('button').forEach(x => x.setAttribute('aria-pressed', x === b ? 'true' : 'false'));
      quien.addEventListener('click', e => {
        const b = e.target.closest('button'); if (!b) return; marca(quien, b);
        lio.innerHTML = datos.map((d, i) => (d.animal === b.dataset.v || d.animal === 'ambos') ? `<button type="button" data-i="${i}" aria-pressed="false">${esc(d.lio)}</button>` : '').join('');
        paso2.hidden = false; res.innerHTML = `<p class="vacio">${esc(res.dataset.espera)}</p>`;
      });
      lio.addEventListener('click', e => {
        const b = e.target.closest('button'); if (!b) return; marca(lio, b);
        const d = datos[b.dataset.i];
        res.innerHTML = `<img src="${esc(d.img)}" width="500" height="500" alt="${esc(d.nombre)}"><div><h3>${esc(d.nombre)}</h3><p class="por-que">${esc(d.por)}</p><span class="precio">${esc(d.precio)}</span><a class="btn" href="${esc(d.url)}">${esc(res.dataset.boton)}</a></div>`;
        res.classList.remove('salta'); void res.offsetWidth; res.classList.add('salta');
      });
    });

    // --- ficha: opciones (color, talla…), fotos, cantidad y palabra gigante ---
    document.querySelectorAll('[data-pc2-ficha]').forEach(ficha => {
      const datos = JSON.parse((ficha.querySelector('[data-pc2-variantes]') || {}).textContent || '[]');
      const grupos = [...ficha.querySelectorAll('[data-pc2-opcion]')], minis = ficha.querySelector('[data-pc2-minis]');
      const foto = ficha.querySelector('[data-pc2-foto]'), escenario = ficha.querySelector('.escenario'), dice = ficha.querySelector('[data-pc2-dice]');
      const idInput = ficha.querySelector('[data-pc2-id]'), anadir = ficha.querySelector('[data-pc2-anadir]'), txt = ficha.querySelector('[data-pc2-txt]'), antes = ficha.querySelector('[data-pc2-antes]');
      const textoBoton = txt ? txt.textContent : '', agotado = window.variantStrings ? window.variantStrings.soldOut : '';
      let actual = datos.find(v => String(v.id) === (idInput && idInput.value)) || datos[0];
      const pinta = v => {
        actual = v;
        grupos.forEach(g => {
          const i = +g.dataset.pc2Opcion;
          g.querySelectorAll('button').forEach(b => {
            b.setAttribute('aria-pressed', b.dataset.valor === v.o[i] ? 'true' : 'false');
            // oculta valores que no existen con lo elegido en las opciones anteriores
            const existe = datos.some(x => x.o[i] === b.dataset.valor && x.o.slice(0, i).every((o, k) => o === v.o[k]));
            b.hidden = !existe;
            b.classList.toggle('agotado', !datos.some(x => x.ok && x.o[i] === b.dataset.valor && x.o.slice(0, i).every((o, k) => o === v.o[k])));
          });
          const et = ficha.querySelector(`[data-pc2-valor="${i}"]`); if (et) et.textContent = v.o[i];
        });
        ficha.style.setProperty('--fondo', v.fondo); ficha.style.setProperty('--palabra', v.palabra);
        if (dice && v.dice) dice.textContent = v.dice;
        ficha.querySelectorAll('[data-pc2-precio]').forEach(p => p.textContent = v.precio);
        if (antes) { antes.textContent = v.antes; antes.hidden = !v.antes; }
        if (idInput) idInput.value = v.id;
        if (anadir) { anadir.disabled = !v.ok; if (txt) txt.textContent = v.ok ? textoBoton : (agotado || textoBoton); }
        if (foto && v.src && !foto.src.startsWith(v.src.split('?')[0])) {
          foto.classList.add('cambia');
          setTimeout(() => {
            foto.removeAttribute('srcset'); foto.src = v.src; escenario.classList.toggle('enmarcada', !v.recorte);
            foto.onload = () => { foto.classList.remove('cambia'); foto.classList.add('entra'); void foto.offsetWidth; foto.classList.remove('entra'); };
          }, 300);
        }
        if (minis) minis.querySelectorAll('button').forEach(m => { m.hidden = v.src.split('?')[0] === m.dataset.src.split('?')[0]; });
        const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u);
      };
      // al tocar un valor: busca la variante con ese valor y lo demás igual; si no existe, la primera que lo tenga
      const busca = (i, valor) => {
        const quiero = actual.o.map((o, k) => k === i ? valor : o);
        return datos.find(x => x.o.every((o, k) => o === quiero[k]) && x.ok)
          || datos.find(x => x.o.every((o, k) => o === quiero[k]))
          || datos.find(x => x.o[i] === valor && x.o.slice(0, i).every((o, k) => o === actual.o[k]) && x.ok)
          || datos.find(x => x.o[i] === valor);
      };
      grupos.forEach(g => g.addEventListener('click', e => { const b = e.target.closest('button'); if (!b) return; const v = busca(+g.dataset.pc2Opcion, b.dataset.valor); if (v) pinta(v); }));
      if (minis) minis.addEventListener('click', e => {
        const m = e.target.closest('button'); if (!m) return;
        const val = m.dataset.valor.toLowerCase().trim();
        const ids = (m.dataset.ids || '').split(',').map(x => x.trim()).filter(Boolean);
        const v = datos.find(x => ids.includes(String(x.id)) && x.ok) || datos.find(x => ids.includes(String(x.id))) || datos.find(x => x.o.join(' / ').toLowerCase() === val) || datos.find(x => x.src.split('?')[0] === m.dataset.src.split('?')[0]);
        if (v) pinta(v);
      });
      if (actual) pinta(actual);
      const cant = ficha.querySelector('[data-pc2-cant]');
      ficha.querySelector('[data-pc2-menos]').addEventListener('click', () => { cant.value = Math.max(1, (+cant.value || 1) - 1); });
      ficha.querySelector('[data-pc2-mas]').addEventListener('click', () => { cant.value = Math.min(99, (+cant.value || 1) + 1); });
      const gigante = ficha.querySelector('.gigante'), vaso = ficha.querySelector('.vaso img');
      if (!reducido && (gigante || vaso)) addEventListener('scroll', () => { const y = scrollY; if (gigante) gigante.style.transform = `translateX(${-y * .45}px)`; if (vaso) vaso.style.rotate = `${Math.min(y * .03, 14)}deg`; }, { passive: true });
    });

    // --- enlace a la guía de tallas: baja hasta ella y la abre ---
    document.querySelectorAll('[data-pc2-guia]').forEach(a => a.addEventListener('click', () => { const g = document.querySelector('#guia-tallas details'); if (g) g.open = true; }));

    // --- preguntas en chat: el fondo y la polaroid cambian con la pregunta abierta ---
    document.querySelectorAll('[data-pc2-charla]').forEach(ch => {
      const pol = ch.querySelector('[data-pc2-polaroid]'), pie = ch.querySelector('[data-pc2-pie]'), gig = ch.querySelector('.gigante');
      ch.querySelectorAll('details').forEach(d => d.addEventListener('toggle', () => {
        if (!d.open) return;
        ch.querySelectorAll('details[open]').forEach(o => { if (o !== d) o.open = false; });
        ch.style.setProperty('--f-fondo', d.dataset.fondo);
        if (pie) pie.textContent = d.dataset.nombre;
        if (pol && d.dataset.foto && !pol.src.startsWith(d.dataset.foto.split('?')[0])) { pol.classList.add('cambia'); setTimeout(() => { pol.removeAttribute('srcset'); pol.src = d.dataset.foto; pol.onload = () => pol.classList.remove('cambia'); }, 220); }
      }));
      if (gig && !reducido) addEventListener('scroll', () => { const r = ch.getBoundingClientRect(); gig.style.transform = `translateX(${r.top * .35 - 200}px)`; }, { passive: true });
    });

    // --- recomendaciones de Shopify en «Hace buena pareja con» ---
    document.querySelectorAll('[data-pc2-recomendaciones]').forEach(caja => {
      fetch(caja.dataset.pc2Recomendaciones).then(r => r.text()).then(html => {
        const nuevo = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-pc2-recomendaciones]');
        if (nuevo && nuevo.querySelector('.tarjeta')) { caja.innerHTML = nuevo.innerHTML; caja.querySelectorAll('.sube').forEach(el => el.classList.add('visto')); }
      }).catch(() => {});
    });

    // --- huellas al pulsar un botón ---
    document.addEventListener('pointerdown', e => {
      const b = e.target.closest('.pc2 .btn'); if (!b || reducido || b.hasAttribute('data-pc2-pulsa')) return;
      for (let i = 0; i < 7; i++) {
        const h = document.createElement('div'); h.className = 'pc2-chispa'; h.innerHTML = HUELLA;
        const a = Math.random() * Math.PI * 2, d = 50 + Math.random() * 60;
        h.style.left = (e.clientX - 11) + 'px'; h.style.top = (e.clientY - 11) + 'px';
        h.style.setProperty('--dx', Math.cos(a) * d + 'px'); h.style.setProperty('--dy', Math.sin(a) * d + 'px'); h.style.setProperty('--r', (Math.random() * 120 - 60) + 'deg');
        document.body.appendChild(h); setTimeout(() => h.remove(), 750);
      }
    });

    // --- productos de la cabecera en carrusel: el que toca va al centro en grande, el anterior se aparta a la izquierda
    //     y el siguiente espera a la derecha, los dos en pequeño. Empieza por el producto elegido en «Producto que sale primero». ---
    document.querySelectorAll('.pc2 .muro-prod').forEach(muro => {
      const es = [...muro.querySelectorAll('.estrella')];
      const n = es.length;
      if (!n) return;
      let c = Math.min(Math.max((+muro.dataset.primero || 1) - 1, 0), n - 1), reloj = null;
      const coloca = (todos = true) => es.forEach((e, j) => {
        const pos = j === c ? 'p-centro' : j === (c + 1) % n ? 'p-izq' : 'p-der';
        if (!todos && pos !== 'p-centro') return;
        e.classList.remove('p-centro', 'p-izq', 'p-der');
        e.classList.add(pos);
      });
      const avanza = () => { c = (c - 1 + n) % n; coloca(); };
      const gira = () => { clearInterval(reloj); reloj = setInterval(avanza, 3000); };
      if (reducido) { coloca(); return; }
      setTimeout(() => coloca(false), 250);
      setTimeout(() => { coloca(); gira(); }, 1100);
      es.forEach((e, j) => {
        e.addEventListener('pointerenter', ev => { if (ev.pointerType === 'mouse') clearInterval(reloj); });
        e.addEventListener('pointerleave', ev => { if (ev.pointerType === 'mouse') gira(); });
      });
    });

    // --- entradas al bajar ---
    const io = new IntersectionObserver(es => es.forEach(en => { if (en.isIntersecting) { en.target.classList.add('visto'); io.unobserve(en.target); } }), { threshold: .15 });
    document.querySelectorAll('.pc2 .sube').forEach((el, i) => { el.style.transitionDelay = (i % 4) * 80 + 'ms'; io.observe(el); });
  });
})();
